import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_DEFICIENCY_TYPES: 'fetchDeficiencyTypes'
}

export const globalActions = getNamespacedBy('deficiencyType', actionTypes)
